// Easter egg tracking utilities

// T->U conversion easter egg
let tToUConversionDetected = false;
const listeners: Set<() => void> = new Set();

export const EasterEggs = {
  setTToUConversionDetected: (detected: boolean) => {
    tToUConversionDetected = detected;
    listeners.forEach(listener => listener());
  },
  
  getTToUConversionDetected: () => tToUConversionDetected,
  
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
  }
};
